export const URL_PARAM_PROPERTY = 'tap3property'

export const URL_PARAM_PROPERTY_VALUE_MAINTENANCE_SCHEDULE = 'MAINTENANCE_MODE_SCHEDULE'
export const URL_PARAM_PROPERTY_VALUE_WEB_APP_JENKINS_BUILD_NUMBER = 'WEB_APP_JENKINS_BUILD_NUMBER'
